/* eslint-disable sonarjs/max-switch-cases */
export const countryShortNameToString = (shortName: string = '', fallback?: string) => {
  switch (shortName.trim().toLowerCase()) {
    case '104':
    case 'at':
      return 'austria'
    case 'bh':
      return 'bahrain'
    case 'ae':
      return 'unitedarabemirates'
    case 'om':
      return 'oman'
    case 'sa':
      return 'saudiarabia'
    case 'qa':
      return 'qatar'
    case '118':
    case 'md':
      return 'moldova'
    case '106':
    case 'cz':
      return 'czechrepublic'
    case '107':
    case 'de':
      return 'germany'
    case '108':
    case 'sk':
      return 'slovakia'
    case '111':
    case 'bg':
      return 'bulgaria'
    case '115':
    case 'ro':
      return 'romania'
    case '117':
    case 'lt':
      return 'lithuania'
    case '120':
    case 'ru':
      return 'russia'
    case '121':
    case 'ua':
      return 'ukraine'
    case '101':
    case 'pl':
      return 'poland'
    case '110':
    case 'hu':
      return 'hungary'
    case 'gr':
      return 'greece'
    case 'es':
      return 'spain'
    case 'it':
      return 'italy'
    case 'se':
      return 'sweden'
    case 'eu':
      return 'europe'
    case 'gb':
      return 'greatbritain'
    case 'nl':
      return 'netherlands'
    case 'be':
      return 'belgium'
    case 'dk':
      return 'denmark'
    case 'fr':
      return 'france'
    case '998':
    case '123':
    case 'ch':
      return 'switzerland'
    case '105':
    case 'hr':
      return 'croatia'
    case '109':
    case 'si':
      return 'slovenia'
    case '114':
    case 'ee':
      return 'estonia'
    case '119':
    case 'lv':
      return 'latvia'
    case '113':
    case 'rs':
      return 'serbia'
    case '112':
    case 'tr':
      return 'turkey'
    case 'xk':
      return 'kosovo'
    case '124':
      return 'deezee'
    case '122':
      return 'EOB2'
    case '999':
      return 'modivo'
    case '777':
      return 'halfprice'
    case '125':
      return 'apparel'
    case '126':
      return 'kosovo'
    case '128':
      return 'ginorossi'
    case '129':
      return 'reno'
    case '666':
      return 'shockprice'
    case '888':
      return 'outlet'
    default:
      return typeof fallback === 'string' ? fallback : 'none'
  }
}

// TODO: Remove and reuse countryShortNameToString instead
export const countryIdToString = (id?: string) => countryShortNameToString(`${id || ''}`.toLowerCase())
